module.exports = __webpack_public_path__ + "img/electric_use.62094adc.svg";